export default {
  page: {
    marginTop: 7,
  },
};
